<template>
  <OurPage :title="$t('title.survey._')">
    <SurveyList
      :items="surveyListData"
      :pagination-data="paginationData"
      :is-loading="isLoading"
      @pageChange="getData"
      @onClickRow="onClickRow"
    />
    <template #header-right>
      <OurLink v-if="getPermission['survey.create']" :route="addRoute">
        <OurButton :text="$t('button.add')" />
      </OurLink>
    </template>
  </OurPage>
</template>

<script>
import SurveyList from "@/views/settings/survey/index/_components/SurveyList.vue";
import { surveyListQuery } from "@/views/settings/survey/index/gql/queries";
import DateService from "@/services/date.service";
import apolloMixin from "@/mixins/apollo.mixin";
import { mapGetters } from "vuex";

export default {
  name: "SurveyIndex",
  components: { SurveyList },
  mixins: [apolloMixin],
  data() {
    return {
      surveyListData: [],
      paginationData: {},
      sorting: {
        column: "createdAt",
        direction: "desc",
      },
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("user", ["getPermission"]),

    addRoute() {
      return { name: "SurveyAdd" };
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page = parseInt(this.$route.query.page) ?? 1) {
      this.isLoading = true;

      try {
        const { surveyList } = await this.$get(surveyListQuery, {
          page,
          orderBy: this.sorting,
        });

        if (surveyList) {
          this.surveyListData = surveyList.data.map((item) => ({
            id: item.id,
            title: item.title,
            validityPeriod: this.formatValidityPeriod(item.startsAt, item.endsAt),
            maxShows: item.maxShows,
          }));
          this.paginationData = surveyList.paginatorInfo;
        }
      } finally {
        this.isLoading = false;
      }
    },

    formatValidityPeriod(startsAt, endsAt) {
      if (!startsAt || !endsAt) {
        return "–";
      }

      const start = DateService.dateConverter(startsAt);
      const end = DateService.dateConverter(endsAt);

      return `${start} – ${end}`;
    },

    onClickRow(id) {
      this.$router.push({ name: "SurveyEdit", params: { id } });
    },
  },
};
</script>
